<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.sex_place')" class="nav-bar page-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="page-body">
      <div class="sex">
        <van-radio-group v-model="radio">
          <div class="item" @click="chooesSex(1)">
            <van-radio name="1">{{$t("setting.man")}}</van-radio>
          </div>
          <div class="item" @click="chooesSex(2)">
            <van-radio name="2">{{$t("setting.female")}}</van-radio>
          </div>
        </van-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    chooesSex(sex){
      this.$http({
        method: 'post',
        data:{sex:sex},
        url: 'user_set_sex'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.radio = sex;
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info',
        headers: {
          lang: window.localStorage.getItem("lang").toLowerCase()
        }
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.radio = res.data.sex;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  padding: 10px 16px 0;
}

.sex{
  background-color: #fff;
  padding: 0 24px;
}

.item{
  font-size: 35px;
  line-height: 50px;
  padding: 30px 0;
  border-bottom: 1px solid #ededed;
}

.item:last-child {
  border-bottom: none;
}

::v-deep .van-radio__label {
  line-height: 50px;
  margin-left: 30px;
  color: #000;
}

::v-deep .van-radio__icon {
  font-size: 30px;
}

::v-deep .van-radio__icon--checked .van-icon {
  color: #fff;
  border-color: #6667e8;
  background-color: #6667e8;
}

.nav-back {
  color: #8795ad;
}

::v-deep .page-nav {
  background: #fff;
}

::v-deep .page-nav .van-nav-bar__title {
  color: #000;
}

::v-deep .page-nav::after {
  border-bottom: 1px solid #ededed;
}
</style>
